module.exports = __webpack_public_path__ + "static/media/install8.2489d7a8.png";